import { useCallback } from 'react'

/**
 * Custom hook to get team name by tournament member ID
 * @param {Array} tournamentMember - Array of tournament members
 * @returns {Function} - Function to get team name
 */
export const useGetTeamName = tournamentMember => {
  return useCallback(
    val => {
      const id = val?.tournamentMemberId || val?.id
      if (!id) {
        return ''
      }

      const findTeam = tournamentMember?.find(el => el?.id === id)

      if (findTeam) {
        return findTeam?.team?.name || findTeam?.user?.nickname
      }

      return ''
    },
    [tournamentMember]
  )
}

